export interface DeductionDocumentSubTypeProps {
  purchaserId: number;
  purchaserKey: string;
  documentTypeId: number;
  documentType: string;
  documentTypeKey: string;
  subtypes: DocumentSubTypeProps[];
}

interface DocumentSubTypeProps {
  documentSubtypeId: number;
  documentSubtype: string;
  documentSubtypeKey: string;
}

export class DeductionDocumentSubType {
  private readonly _purchaserId: number;
  private readonly _purchaserKey: string;
  private readonly _documentTypeId: number;
  private readonly _documentType: string;
  private readonly _documentTypeKey: string;
  private readonly _subtypes: DocumentSubTypeProps[];

  constructor(props: DeductionDocumentSubTypeProps) {
    this._purchaserId = props.purchaserId;
    this._purchaserKey = props.purchaserKey;
    this._documentTypeId = props.documentTypeId;
    this._documentType = props.documentType;
    this._documentTypeKey = props.documentTypeKey;
    this._subtypes = props.subtypes;
  }

  public get purchaserId(): number {
    return this._purchaserId;
  }

  public get purchaserKey(): string {
    return this._purchaserKey;
  }

  public get documentTypeId(): number {
    return this._documentTypeId;
  }

  public get documentType(): string {
    return this._documentType;
  }

  public get documentTypeKey(): string {
    return this._documentTypeKey;
  }

  public get subtypes(): DocumentSubTypeProps[] {
    return this._subtypes;
  }
}

export class DocumentSubType {
  private readonly _documentSubtypeId: number;
  private readonly _documentSubtype: string;
  private readonly _documentSubtypeKey: string;

  constructor(props: DocumentSubTypeProps) {
    this._documentSubtypeId = props.documentSubtypeId;
    this._documentSubtype = props.documentSubtype;
    this._documentSubtypeKey = props.documentSubtypeKey;
  }

  public get documentSubtypeId(): number {
    return this._documentSubtypeId;
  }

  public get documentSubtype(): string {
    return this._documentSubtype;
  }

  public get documentSubtypeKey(): string {
    return this._documentSubtypeKey;
  }
}
